module.exports = __webpack_public_path__ + "static/media/EnvPromo-RedTree_01.e9da9533.jpg";